import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab } from 'semantic-ui-react';
import SystemSetting from '../../components/SystemSetting';
import { API, isRoot } from '../../helpers';
import OtherSetting from '../../components/OtherSetting';
import PersonalSetting from '../../components/PersonalSetting';
import OperationSetting from '../../components/OperationSetting';
import AutoUpdateSetting from '../../components/AutoUpdateSetting';
import AutoStartSetting from '../../components/AutoStartSetting';
import ChannelProxySetting from '../../components/ChannelProxySetting';
import { StudioHero, StudioPage } from '../../components/StudioPage';
import './Settings.css';

const Setting = () => {
  const { t } = useTranslation();
  // 开机自启只有 Windows 有：后端返回 supported=false 时不加这个 tab，
  // Linux/macOS 的设置页与之前完全一致。
  const [autoStartSupported, setAutoStartSupported] = useState(false);

  useEffect(() => {
    if (!isRoot()) return;
    API.get('/api/autostart')
      .then((res) => {
        if (res.data?.success && res.data?.data?.supported) {
          setAutoStartSupported(true);
        }
      })
      .catch(() => {});
  }, []);

  let panes = [
    {
      menuItem: t('setting.tabs.personal'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <PersonalSetting />
        </Tab.Pane>
      ),
    },
  ];

  if (isRoot()) {
    panes.push({
      menuItem: t('setting.tabs.operation'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <OperationSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.system'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <SystemSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.other'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <OtherSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.proxy_subscription'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <ChannelProxySetting />
        </Tab.Pane>
      ),
    });
    if (autoStartSupported) {
      panes.push({
        menuItem: t('setting.tabs.autostart'),
        render: () => (
          <Tab.Pane attached={false} className='settings-tab-pane'>
            <AutoStartSetting />
          </Tab.Pane>
        ),
      });
    }
    panes.push({
      menuItem: t('setting.tabs.autoupdate'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <AutoUpdateSetting />
        </Tab.Pane>
      ),
    });
  }

  return (
    <StudioPage className='studio-settings-page'>
      <StudioHero
        icon='setting'
        kicker='AI STUDIO / SETTINGS'
        title={t('setting.title')}
        description={t('setting.studio_subtitle')}
      />
      <div className='settings-workspace studio-surface'>
        <Tab
          className='studio-tabs studio-settings-content'
          menu={{
            secondary: true,
            pointing: true,
            className: 'settings-tab',
          }}
          panes={panes}
        />
      </div>
    </StudioPage>
  );
};

export default Setting;
